"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
var _SendReceiveSidePaneComponent = _interopRequireDefault(require("../../components/SendReceiveSidePane/SendReceiveSidePaneComponent"));
var _withdrawActions = require("../../redux/actions/withdrawActions");
var _transferActions = require("../../redux/actions/transferActions");
var _transferRequestActions = require("../../redux/actions/transferRequestActions");
var _positionSelectors = require("../../redux/selectors/positionSelectors");
var _config = _interopRequireDefault(require("../../config"));
var _eotcWithdrawActions = require("../../redux/actions/eotcWithdrawActions");
var _positionActions = require("../../redux/actions/positionActions");
var _excluded = ["selectedAccountId"],
  _excluded2 = ["selectedAccountId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var productId = (0, _lodash.get)(ownProps, 'product.ProductId', null);
  var productSymbol = (0, _lodash.get)(ownProps, 'product.ProductSymbol', null);
  var position = (0, _positionSelectors.positionByProductIdSelector)(productId)(state);
  var decimalPlaces = state.apexCore.product.decimalPlaces[productSymbol];
  var product = _objectSpread(_objectSpread({}, ownProps.product), {}, {
    decimalPlaces: decimalPlaces
  });
  var _config$global = _config["default"].global,
    allowTransfer = _config$global.allowTransfer,
    hideFees = _config$global.hideFees;
  var _state$withdraw = state.withdraw,
    fee = _state$withdraw.withdrawFee,
    template = _state$withdraw.template,
    AccountProviderId = _state$withdraw.AccountProviderId;
  var selectedAccountId = state.user.selectedAccountId;
  var TicketAmount = (0, _lodash.get)(state, ['withdraw', 'TicketAmount'], 0);
  var verificationLevelConfig = (0, _lodash.get)(state, ['user', 'verificationLevelConfigs', 'Products'], []).find(function (i) {
    return i.ProductId === productId;
  }) || {};
  return {
    position: position,
    fee: fee,
    template: template,
    product: product,
    allowTransfer: allowTransfer,
    hideFees: hideFees,
    selectedAccountId: selectedAccountId,
    TicketAmount: TicketAmount,
    AccountProviderId: AccountProviderId,
    verificationLevelConfig: verificationLevelConfig
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    receiveFunds: function receiveFunds(_ref) {
      var selectedAccountId = _ref.selectedAccountId,
        rest = _objectWithoutProperties(_ref, _excluded);
      return dispatch((0, _transferActions.requestTransferFunds)(rest, ownProps.name)).then(function () {
        return dispatch((0, _transferRequestActions.getTransferRequestsRequested)(selectedAccountId));
      });
    },
    sendFunds: function sendFunds(_ref2) {
      var selectedAccountId = _ref2.selectedAccountId,
        rest = _objectWithoutProperties(_ref2, _excluded2);
      return dispatch((0, _transferActions.transferFunds)(rest, ownProps.name)).then(function () {
        return dispatch((0, _transferActions.getTransfers)(selectedAccountId));
      });
    },
    sendToAddress: function sendToAddress(payload) {
      return dispatch((0, _withdrawActions.createWithdrawTicket)(payload, ownProps.name));
    },
    getWithdrawFee: function getWithdrawFee(productId, amount, AccountProviderId) {
      return dispatch((0, _withdrawActions.getWithdrawFee)(productId, amount, AccountProviderId));
    },
    fetchAccountWithdrawInfos: function fetchAccountWithdrawInfos() {
      return dispatch((0, _eotcWithdrawActions.fetchAccountWithdrawInfos)());
    },
    selectPositionAndSave: function selectPositionAndSave(productId) {
      return dispatch((0, _positionActions.selectPositionAndSave)(productId));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SendReceiveSidePaneComponent["default"]);